module.exports = require("core-js/modules/es.math.to-string-tag.js");